import { render, staticRenderFns } from "./live-pay.vue?vue&type=template&id=72326672&scoped=true&"
import script from "./live-pay.vue?vue&type=script&lang=js&"
export * from "./live-pay.vue?vue&type=script&lang=js&"
import style0 from "./live-pay.vue?vue&type=style&index=0&id=72326672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72326672",
  null
  
)

export default component.exports